import React from "react";

import {
  ContainerHeader,
  HeaderTitle,
  HeaderSubtitle,
  GridContainerTemplates,
  TitleTemplates
} from "./styles";

import { TextContent, Text } from "../../myclausules/screen/styles";

const ScreenHome: React.FC = () => {
  return (
    <>
      <ContainerHeader>
        <HeaderTitle>
          Seja bem-vindo 1ª plataforma de Legal Design do mundo.
        </HeaderTitle>
        <HeaderSubtitle>
          Aqui, você conseguirá criar documentos jurídicos a partir de templates
          pré-definidos e personalizáveis.
        </HeaderSubtitle>
      </ContainerHeader>

      <TitleTemplates>Novos templates</TitleTemplates>

      <GridContainerTemplates>
        <TextContent>
          <Text>Novos templates em breve</Text>
        </TextContent>
      </GridContainerTemplates>
    </>
  );
};

export default ScreenHome;
